import { Button } from '@sunwebgroup/uds-ui/button'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { useMemo } from 'react'

import { useIntl } from '@/intl'
import { buildRebookingSearchUrl } from '@/scopes/account/booking-details/infrastructure/browser/rebookingSearchUrlBuilder'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import styles from '@/scopes/account/booking-details/pages/components/ManageBookingSection/ManageBookingSection.module.css'
import {
  getCanRebookSameAccommodation,
  getSameAccommodationRebookingUrl,
} from '@/scopes/account/booking-details/pages/selectors'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'

export function RebookingSheetContent() {
  const { formatMessage } = useIntl()
  const links = useConfiguration('links')
  const canRebookSameAccommodation = useBookingDetailsStore(getCanRebookSameAccommodation)
  const sameAccommodationUrl = useBookingDetailsStore(getSameAccommodationRebookingUrl)
  const participants = useBookingDetailsStore(state => state.participants)
  const bookingParticipantIds = useBookingDetailsStore(state => state.bookingParticipantIds)
  const transportType = useBookingDetailsStore(state => state.transportType)
  const rebookingState = useBookingDetailsStore(state => state.rebooking?.state)
  const rebookingSearchUrl = useBookingDetailsStore(state => state.rebookingSearchUrl)
  const otherAccommodationUrl = useMemo(() => {
    if (!rebookingSearchUrl) {
      return ''
    }

    return buildRebookingSearchUrl(rebookingSearchUrl, {
      participants: bookingParticipantIds
        .map(participantId => participants[participantId])
        .filter(participant => participant !== undefined),
      transportType,
    })
  }, [rebookingSearchUrl, bookingParticipantIds, participants, transportType])

  if (rebookingState === 'manual') {
    return (
      <RichText
        innerHTML={formatMessage({ id: 'booking_details_manage_booking_rebook_sheet_manual_content' })}
      />
    )
  }

  return (
    <div className={styles.rebookingContent}>
      <RichText
        className={styles.rebookingSteps}
        innerHTML={formatMessage({ id: 'booking_details_manage_booking_rebook_sheet_online_content' })}
      />
      <div className={styles.rebookingActions}>
        {canRebookSameAccommodation && sameAccommodationUrl && (
          <Button as="a" variant="secondary" href={sameAccommodationUrl} target="_blank" rel="noopener noreferrer">
            {formatMessage({ id: 'booking_details_manage_booking_rebook_sheet_online_same_accomodation_button_label' })}
          </Button>
        )}
        {rebookingSearchUrl && (
          <Button as="a" variant="secondary" href={otherAccommodationUrl} target="_blank" rel="noopener noreferrer">
            {formatMessage({ id: 'booking_details_manage_booking_rebook_sheet_online_other_accommodation_button_label' })}
          </Button>
        )}
      </div>
      <RichText
        className={styles.rebookingDisclaimer}
        innerHTML={formatMessage(
          { id: 'booking_details_manage_booking_rebook_sheet_online_disclaimer' },
          { link: links.conditions },
        )}
      />
    </div>
  )
}
